<template>
  <div>
    <v-form ref="form">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <v-row>
          <v-col cols="5">
            <v-text-field
              :value="submitItem.disasterName"
              label="災害名称"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              :value="emergencyStatusName"
              label="緊急事態区分"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-textarea
              v-model="municipNames"
              label="市町村"
              placeholder=" "
              rows="3"
              readonly
            >
            </v-textarea>
          </v-col>
          <v-col cols="12" sm="8" md="6" lg="6">
            <v-textarea
              v-model="organizeNames"
              label="組織名"
              placeholder=" "
              rows="3"
              readonly
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-divider class="mb-1" />
      </v-container>
      <v-container fluid>
        <v-row>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="submitItem.deliveryTitle"
              label="件名"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="8" lg="6">
            <v-dialog v-model="uploadDialog" persistent>
              <template v-slot:activator="{ on, attrs }">
                <div class="d-flex">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="mx-2 mt-3"
                    color="primary"
                  >
                    ファイルの参照
                  </v-btn>
                  <v-tooltip
                    right
                    :open-on-hover="false"
                    color="grey lighten-4"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        @click="on.click"
                        @blur="on.blur"
                        retain-focus-on-click
                      >
                        <v-icon>mdi-help-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: black">
                      最大10個の添付ファイルが登録可能。<br />
                      ファイルサイズの合計が20Mバイト以内であること。<br />
                      以下の拡張子であること。<br />
                      .png、.gif、.jpeg、.jpg、.txt、.pdf<br />
                      動画ファイルはアップロード不可<br />
                    </span>
                  </v-tooltip>
                </div>
              </template>
              <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                  <v-toolbar dense color="white">
                    <v-toolbar-title>ファイル添付</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-data-table
                    :headers="filesHeaders"
                    :items="viewFileItems"
                    class="elevation-1 mt-2"
                    locale="ja-jp"
                    item-key="imageNo"
                    hide-default-footer
                    no-data-text="データはありません。"
                  >
                    <template v-slot:[`item.file`]="{ item }">
                      <v-file-input
                        v-model="item.file"
                        placeholder=" "
                        disabled
                        prepend-icon="mdi-paperclip"
                        class="mt-2"
                        dense
                      >
                        <template v-slot:selection="{ text }">
                          <div class="list-file-name">
                            {{ text }}
                          </div>
                        </template>
                      </v-file-input>
                    </template>
                    <template v-slot:[`item.imageTitle`]="{ item }">
                      <v-text-field
                        v-model="item.imageTitle"
                        placeholder=" "
                        class="mt-2"
                        dense
                        disabled
                      >
                      </v-text-field>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mx-2"
                    color="primary"
                    @click="uploadDialog = false"
                  >
                    戻る
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="8">
            <v-textarea
              v-model="submitItem.deliveryBody"
              counter="1000"
              maxlength="1000"
              label="通知文"
              placeholder=" "
              readonly
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-btn
      class="mx-2"
      color="primary"
      v-if="hasEditAuth()"
      @click="onClickDuplicate"
    >
      コピーして編集
    </v-btn>
    <v-btn class="mx-2" color="primary" @click="onClickReturn">戻る</v-btn>
    <v-overlay :value="overlay" opacity="1" color="white" z-index="2147483647">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Vue from "vue";
import Disaster from "@/plugins/disaster";
import messageUtils from "@/mixins/message-utils";
import { arrayCount } from "@/js/utils";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { ScreenCrud } from "@/js/value-objects/screen-crud";
import { ScreenId } from "@/js/value-objects/screen-id";

const allAreaRepository = RepositoryFactory.get("allArea");
const organizeMstRepository = RepositoryFactory.get("organizeMst");

Vue.use(Disaster);
export default {
  mixins: [messageUtils],
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage")
  },
  props: {
    item: {
      type: Object,
      required: false,
      default: undefined
    }
  },
  data: () => ({
    overlay: false,
    screenId: ScreenId.SF1802,
    submitItem: {
      disasterName: "",
      emergCls: EmergencyClass.NL,
      deliveryBody: "",
      deliveryTitle: "",
      attachFiles: []
    },
    uploadDialog: false,
    viewFileItems: [],
    unfinishedDisasters: [],
    municipalities: [],
    organizations: []
  }),

  computed: {
    screenTitle() {
      return ScreenId.getScreenTitle(this.screenId);
    },

    filesHeaders() {
      return [
        {
          text: "ID",
          align: " d-none",
          value: "imageNo",
          sortable: false
        },
        {
          text: "ファイル",
          value: "file",
          sortable: false
        },
        {
          text: "タイトル",
          value: "imageTitle",
          sortable: false
        }
      ];
    },

    municipNames() {
      // 市町村名を連結して返す
      const municipList = this.municipalities
        .filter(municipality =>
          this.item.dest.municip_codes.includes(municipality.municip_code)
        )
        .map(municipality => municipality.municip_name);
      return municipList.join();
    },

    organizeNames() {
      // 組織名を連結して返す
      const organizationList = this.organizations
        .filter(organization =>
          this.item.dest.organize_ids.includes(organization.organize_id)
        )
        .map(organization => organization.organize_name);
      return organizationList.join();
    },

    emergencyStatusName() {
      return EmergencyClass.factory(this.submitItem.emergCls).toName();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;

      await Promise.all([
        // 市町村一覧
        allAreaRepository.getAllArea(),
        // 組織情報
        organizeMstRepository.list(this.screenId)
      ])
        .then(values => {
          this.municipalities = values[0].data.results[0].municipalities.filter(
            m => m.disp_flg !== "1"
          );
          this.organizations = values[1].data.results.map(organization => {
            const municipInfo = this.municipalities.find(
              municipality =>
                municipality.municip_code === organization.municip_code
            );
            if (municipInfo) {
              organization.organize_name =
                municipInfo.municip_name + " : " + organization.organize_name;
            }
            return organization;
          });
        })
        .catch(e => {
          this.handleError(e, this.screenId, "manager-order-management");
        });

      // 現在のデータを画面に表示
      if (this.item) {
        this.submitItem.disasterName = this.item.disaster_name;
        this.submitItem.emergCls = this.item.emerg_cls;
        this.submitItem.deliveryTitle = this.item.delivery_title;
        this.submitItem.deliveryBody = this.item.delivery_body;
        // 添付ファイル
        const attachFiles = this.item.attach_files;
        if (arrayCount(attachFiles) > 0) {
          this.submitItem.attachFiles = attachFiles.map(attachFile => {
            const pushItem = {
              imageNo: attachFile.image_no,
              imageTitle: attachFile.image_title,
              imageFileName: attachFile.image_filename,
              file: new File([""], attachFile.image_filename),
              s3object: attachFile.s3object
            };
            return pushItem;
          });
          // ファイル情報参照ダイアログに値を設定
          this.viewFileItems = this.submitItem.attachFiles;
        }
      }
      this.overlay = false;
    },

    /**
     * 編集画面の権限があるかチェック
     */
    hasEditAuth() {
      const editScreenId = ScreenId.SF1803;
      const editAuth = this.$screenAuthority.find(
        auth => auth.screen_id === editScreenId
      );
      if (editAuth) {
        const screenCrud = ScreenCrud.factory(editAuth.screen_crud);
        return screenCrud.isOperation();
      } else {
        return false;
      }
    },

    /**
     * コピーして編集ボタン押下時処理
     */
    onClickDuplicate() {
      this.$router.push({
        name: "manager-order-duplicate",
        params: {
          item: this.item
        }
      });
    },

    /**
     * 戻るボタン押下時処理
     */
    onClickReturn() {
      this.$router.push("/manager-order");
    }
  }
};
</script>
<style scoped>
.list-file-name {
  color: black;
}
</style>
